import { ToastContainer, toast } from 'react-toastify';
import apiClient from "../network/apiClient";

class ApiProvider {


  async getCategory(input) {
    try {
      const response = await apiClient.get(`categories`);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: true, response: response };
      } else {
        // notification.showAlertNotification(message, false);
        return null;
      }
    } catch (error) {

      return null;
    }
  }

  async getBanner(input) {
    try {
      const response = await apiClient.get(`banner`);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: true, response: response };
      } else {
        // notification.showAlertNotification(message, false);
        return null;
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);

      return null;
    }
  }



  async getProduct(input) {
    try {
      const response = await apiClient.get(`product/list/dtls?${input ? input : ''}`);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: true, response: response };
      } else {
        // notification.showAlertNotification(message, false);
        return null;
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);

      return null;
    }
  }

  async getProductDetails(input) {
    try {
      const response = await apiClient.get(`product/${input}`);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: true, response: response };
      } else {
        // notification.showAlertNotification(message, false);
        return null;
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);

      return null;
    }
  }

  async getProductsByCategoryId(categoryId) {
    try {
      const response = await apiClient.get(`product-categories/${categoryId}`);
      if (response.status == 200 || response.status == 201) {
        return { status: true, response: response };
      }
      return null;
    } catch (error) {
      return null;
    }
  }

  async getCourse(input) {
    try {
      const response = await apiClient.get(`course/get`);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: true, response: response };
      } else {
        // notification.showAlertNotification(message, false);
        return null;
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);

      return null;
    }
  }

  async getCurriculam(input) {
    try {
      const response = await apiClient.get(`curriculam/get`);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: true, response: response };
      } else {
        // notification.showAlertNotification(message, false);
        return null;
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);

      return null;
    }
  }

  async getReview(input) {
    try {
      const response = await apiClient.get(`review/get`);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: true, response: response };
      } else {
        // notification.showAlertNotification(message, false);
        return null;
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);

      return null;
    }
  }

  async register(input) {
    try {
      const response = await apiClient.post("user", input); // Updated endpoint
      console.log(response, "response");

      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        toast.success(message)
        return { status: response.status, response: response };
      } else {
        toast.error(message)
        return {
          status: false,
          response: response
        };
      }
    } catch (error) {
      console.log(error, "error");

      // notification.showAxiosErrorAlert(error);
      return {
        status: false,
        response: error
      }
    }
  }


  async login(input) {
    try {
      const response = await apiClient.post("login", input); // Updated endpoint
      console.log(response, "response");

      const message = response.data?.message ?? "Something went wrong";
      console.log(message, "message");

      if ((response.status == 200 || response.status == 201) && response) {
        console.log("Login success toast", message);
        toast.success(message)

        return {
          status: response.status,
          response: response.data
        };
      } else {
        console.log("enter else");
        toast.error(message)

        return {
          status: false,
          response: response
        };
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);
      return {
        status: false,
        response: error
      };
    }
  }

  async logout() {
    try {
      const response = await apiClient.post("logout");
      const message = response.data?.message ?? "Logged out successfully";
      if (response.status === 200 || response.status === 201) {
        toast.success(message);
        return { status: true, response: response.data };
      } else {
        toast.error(message);
        return { status: false, response: response };
      }
    } catch (error) {
      toast.success("Logged out successfully");
      return { status: false, response: error };
    }
  }

  async getCarouselCourse(input) {
    try {
      const response = await apiClient.get(`course/course-carousel?limit=` + input);
      const message = response.data?.message ?? "Something went wrong"
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: true, response: response };
      } else {
        // notification.showAlertNotification(message, false);
        return null;
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);

      return null;
    }
  }

  async getFacilitors(input) {
    try {
      const response = await apiClient.get("about-us/get-facilitors", input);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: response.status, response: response };
      } else {
        // notification.showAlertNotification(message, false);/
        return null;
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);
      return null;
    }
  }

  async getFacilitorDetail(input) {
    try {
      const response = await apiClient.get(`about-us/get-facilitor-details/${input}`);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: response.status, response: response };
      } else {
        // notification.showAlertNotification(message, false);/
        return null;
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);
      return null;
    }
  }

  async addAddress(input) {
    try {
      const response = await apiClient.post("address", input);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // toast.success(message)
        return { status: response.status, response: response };
      } else {
        // toast.error(message)
        return {
          status: false,
          response: response
        };
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);
      return {
        status: false,
        response: error
      }
    }
  }

  async getAddress(userID, type) {
    try {
      const response = await apiClient.get(`address/${userID}`, {
        params: { type }
      });

      if (response.status === 200 || response.status === 201) {
        return { status: response.status, response: response.data };
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  }

  async getUserDetails(userID) {
    try {
      const response = await apiClient.get(`user/${userID}`);

      if (response.status === 200 || response.status === 201) {
        return { status: response.status, response: response.data };
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  }

  async updateUserDetails(userID, input) {
    try {
      const response = await apiClient.put(`update-user/${userID}`, input);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status === 200 || response.status === 201) {
        return { status: response.status, response: response.data };
      } else {
        return null;
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Failed to update user details";
      toast.error(errorMessage);
      return null;
    }
  }

  async getOrders(status, page = 0, limit = 10) {
    try {
      const response = await apiClient.get('orders', {
        params: {
          ...(status && status !== 'All' ? { orderStatus: status } : {}),
          page: page,
          limit: limit
        }
      });

      if (response.status === 200 || response.status === 201) {
        return { status: response.status, response: response.data };
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  }

  async orderDetails(id) {
    try {
      const response = await apiClient.get(`orders/details/${id}`);
      if (response.status === 200 || response.status === 201) {
        return { status: response.status, response: response.data };
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  }

  async cancelOrder(id, input) {
    try {
      const response = await apiClient.patch(`orders/cancel/${id}`, input);
      if (response.status === 200 || response.status === 201) {
        return { status: response.status, response: response.data };
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  }

  async createReturnOrder(input) {
    try {
      const response = await apiClient.post(`return-orders`, input);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      } else {
        return { status: false, response: response.data };
      }
    } catch (error) {
      console.error("Error in createReturnOrder:", error);
      return { status: false, response: error?.response?.data || error };
    }
  }

  async getReturnOrders(userId, page = 0, limit = 10) {
    try {
      const response = await apiClient.get(`return-orders`, {
        params: {
          page: page,
          limit: limit,
          type: 'User',
          userId: userId
        }
      });
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      } else {
        return { status: false, response: response.data };
      }
    } catch (error) {
      console.error("Error in getReturnOrders:", error);
      return { status: false, response: error?.response?.data || error };
    }
  }

  async updateOrderStatus(input) {
    try {
      const response = await apiClient.put(`orders/update-status`, input);
      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      } else {
        return { status: false, response: response.data };
      }
    } catch (error) {
      console.error("Error in updateOrderStatus:", error);
      return { status: false, response: error?.response?.data || error };
    }
  }

  async getOrderCounts() {
    try {
      const response = await apiClient.get('order-counts');
      console.error("response :", response);

      if (response.status === 200 || response.status === 201) {
        return { status: true, response: response.data };
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  }

  async updateAddress(UserAddressId, input) {
    try {
      const response = await apiClient.patch(`address/${UserAddressId}`, input);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: response.status, response: response };
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);
      return {
        status: false,
        response: error
      }
    }
  }

  async deleteAddress(UserAddressId) {
    try {
      const response = await apiClient.delete(`address/${UserAddressId}`);

      if (response.status === 200 || response.status === 201) {
        return { status: response.status, response: response.data };
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  }

  async emailverfiy(input) {
    try {
      const response = await apiClient.get(`users/verify/${input}`);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: response.status, response: response };
      } else {
        // notification.showAlertNotification(message, false);/
        return null;
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);
      return null;
    }
  }

  async getManagementTeams(input) {
    try {
      const response = await apiClient.get("about-us/get-management-team", input);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: response.status, response: response };
      } else {
        // notification.showAlertNotification(message, false);/
        return null;
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);
      return null;
    }
  }

  async getManagementTeamsDetail(input) {
    try {
      const response = await apiClient.get(`about-us/get-management-team-details/${input}`);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: response.status, response: response };
      } else {
        // notification.showAlertNotification(message, false);/
        return null;
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);
      return null;
    }
  }


  async newsLetter(input) {
    try {
      const response = await apiClient.post("news-letter/add-newsletter", input);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        toast.success(message)
        return { status: response.status, response: response };
      } else {
        toast.error(message)
        return {
          status: false,
          response: response
        };
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);
      return {
        status: false,
        response: error
      }
    }
  }

  async requestForgetPasswordOtp(input) {
    try {
      const response = await apiClient.post("users/forget-password", input);
      console.log(response, "response");

      const message = response.data?.message ?? "Something went wrong";
      console.log(message, "message");

      if ((response.status == 200 || response.status == 201) && response) {
        // toast.success(message)
        return {
          status: response.status,
          response: response.data
        };
      } else {
        // toast.error(message)
        return {
          status: false,
          response: response
        };
      }
    } catch (error) {
      return {
        status: false,
        response: error
      };
    }
  }

  async verifyForgetPasswordOtp(input) {
    try {
      const response = await apiClient.post("users/verify-forget-password-otp", input);
      console.log(response, "verify OTP response");

      const message = response.data?.message ?? "Something went wrong";

      if (response.status == 200 || response.status == 201) {
        // toast.success(message);
        return {
          status: response.status,
          response: response.data
        };
      } else {
        // toast.error(message);
        return {
          status: false,
          response: response
        };
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "OTP verification failed";
      toast.error(errorMessage);
      return {
        status: false,
        response: error
      };
    }
  }

  async resetPassword(input) {
    try {
      const response = await apiClient.post("users/reset-password", input);
      console.log(response, "reset password response");

      const message = response.data?.message ?? "Something went wrong";

      if (response.status == 200 || response.status == 201) {
        // toast.success(message);
        return {
          status: response.status,
          response: response.data
        };
      } else {
        // toast.error(message);
        return {
          status: false,
          response: response
        };
      }
    } catch (error) {
      const errorMessage = error?.response?.data?.message || "Password reset failed";
      toast.error(errorMessage);
      return {
        status: false,
        response: error
      };
    }
  }

  async getCourseCalender(input) {
    try {
      const response = await apiClient.get(`course/calander-get`, {
        params: { date: input }
      });
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: response.status, response: response };
      } else {
        // notification.showAlertNotification(message, false);/
        return null;
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);
      return null;
    }
  }
  async getPaymentMethod(input) {
    try {
      const response = await apiClient.get("payment/get-paymentmethods", input);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: response.status, response: response };
      } else {
        // notification.showAlertNotification(message, false);/
        return null;
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);
      return null;
    }
  }

  async getCurrency(input) {
    try {
      const response = await apiClient.get("payment/get-currency", input);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: response.status, response: response };
      } else {
        // notification.showAlertNotification(message, false);/
        return null;
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);
      return null;
    }
  }

  async certificateView(input) {
    try {
      const response = await apiClient.post("course/certificate-view", input, {
        responseType: 'blob',
      });
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        // notification.showAlertNotification(response.data.message, true);
        return { status: response.status, response: response };
      } else {
        // notification.showAlertNotification(message, false);/
        return null;
      }
    } catch (error) {
      // notification.showAxiosErrorAlert(error);
      return null;
    }
  }

  async getDashboardData(userId) {
    try {
      const response = await apiClient.get(`user/dashboard-data/${userId}`);
      const message = response.data?.message ?? "Something went wrong";
      if (response.status == 200 || response.status == 201) {
        return { status: response.status, response: response };
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  }


}

const apiProvider = new ApiProvider()
export default apiProvider